import { uploadService } from './../../../../shared/uploadService';
import { WorkFlowService } from './../../../../workFlowModule/work-flow/work-flow/services/work-flow.service';
import { FormMAsterService } from './../../../../DynamicFormsModule/formsMaster/services/formMaster.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ServicesService } from './../../services/servicesService';
import { Component, OnInit } from '@angular/core';
import { listKeyitem } from '../../../../shared/Models/SelectItems';
import { Service } from '../../models/ServiceRate';
import { NgForm } from '@angular/forms';
import { combineLatest, of } from 'rxjs';
import { catchError, filter, finalize, switchMap } from 'rxjs/operators';
import { debug } from 'console';
import { FileVm } from '../../../../shared/Models/fileVm';
import { NavigationEnd, Route, Router } from '@angular/router';

@Component({
  selector: 'ngx-add-service',
  templateUrl: './add-service.component.html',
  styleUrls: ['./add-service.component.css'],
})
export class AddServiceComponent implements OnInit {
  id: number;
  listKeyitem: listKeyitem[] = [];
  model: Service;
  isEdit = false;
  isLoading: boolean = false;
  fileName: string;
  file: any;
  formData: FormData;
  finishLoading = false;
  imgURL: any;
  public imagePath;
  public message: string;
  validPhoto: boolean = true;
  submit: boolean = false;
  typeInvalid = false;
  benInvalid = false;
  inputlist: any[] = [];
  dynmicFormList: any[] = [];
  attachments: FormData = new FormData();
  previousAttachments: any;
  newPhotoUploaded = false;
  uploadingVideo: boolean = false;
  constructor(
    private service: ServicesService,
    private diagRef: NbDialogRef<AddServiceComponent>,
    private toast: NbToastrService,
    private uploadService: uploadService,
    private dFormService: FormMAsterService,
    private wfService: WorkFlowService,
    private route: Router
  ) {}
  preview(files) {
    if (files.length === 0) return;

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }

    const reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
    this.file = files;
    this.formData = new FormData();
    for (const filee of this.file) {
      this.fileName = filee.name;
      this.file = filee;
      this.formData.append(filee.name, filee);
    }
    this.newPhotoUploaded = true;
    this.validPhoto = true;
  }
  ngOnInit(): void {
  this.route.events.subscribe(()=>{
      this.diagRef.close('false');
  })
    this.model = {isActive: true} as Service;

    if (!this.isEdit) {
      this.model.description = '';
      this.model.descriptionEN = '';
      this.model.conditionOfServiceAR = '';
      this.model.conditionOfServiceEN = '';

      this.inputlist.push('');
      this.service.getCreateNew().subscribe((res) => {
        this.listKeyitem = res;
        this.wfService.getCreateNew().subscribe((res) => {
          this.dynmicFormList = res[0].values;
        });
        this.finishLoading = true;
      });
      this.uploadService.updateFiles({ files: [], previousAttachments: [] });
    } else {
      this.service.getUpdate(this.id).subscribe((res) => {
        this.model = res.entity;

        if (this.model.guideFileName != null) {
          this.previousAttachments.push({
            fileName: this.model.guideFileName.split('/').pop(),
            path: this.model.guideFileName,
          } as FileVm);

          this.uploadService.updateFiles({ files: [], previousAttachments: this.previousAttachments });
        }

        console.log('this.model', this.model);
        this.listKeyitem = res.selectListItems;
        this.wfService.getCreateNew().subscribe((res) => {
          this.dynmicFormList = res[0].values;
        });

        this.finishLoading = true;
      });
    }
  }
  removePhoot() {
    this.imgURL = null;
    this.file = null;
    this.model.fileName = null;
    this.validPhoto = false;
  }
  uploadFile(evt: any) {
    this.attachments = new FormData();
    for (let file of evt.files) {
      this.attachments.append(file.name, file);
    }
  }

  uploadVideo(evt: any) {
    this.uploadingVideo = true;
    this.attachments = new FormData();
    for (let file of evt) {
      this.attachments.append(file.name, file);
    }

    this.service.uploadFile(this.attachments).subscribe(
      (res) => {
        this.model.videoURL = res.fileName;
        this.uploadingVideo = false;
      },
      (error) => {
        this.uploadingVideo = false;
      }
    );
  }

  benSelected() {
    this.benInvalid = false;
  }
  typeSelected() {
    this.typeInvalid = false;
  }

  addinput() {
    this.inputlist.push('');
  }

  get typeValidity() {
    return this.model.serviceTypeId == 0 || !this.model.serviceTypeId ? false : true;
  }
  get benValidity() {
    return this.model.beneficiariesIds == null || this.model.beneficiariesIds.length == 0 ? false : true;
  }

  save(form: NgForm) {
    this.submit = true;

    if (this.imgURL == null) {
      this.validPhoto = false;
    }
    if (!this.validPhoto || !this.typeValidity || this.benInvalid) {
      if (!this.typeValidity) this.typeInvalid = true;
      if (this.benInvalid) this.benInvalid = true;
      return;
    } else {
      this.isLoading = true;
      const imgUpload$ = this.uploadService.uploadImage(this.formData);
      const attachments = this.uploadService.uploadFile();

      combineLatest([imgUpload$, attachments])
        .pipe(
          switchMap(([img, file]) => {
            this.model.fileName = img.fileName;
            this.model.guideFileName = file.fileName;

            return this.service.post(this.model);
          }),
          finalize(() => (this.isLoading = false))
        )
        .subscribe({
          next: () => {
            this.toast.success('تم الحفظ بنجاح', 'نجاح');
            this.diagRef.close('true');
          },
        });
    }

    // if (this.model.serviceTypeId == 0 || this.model.serviceTypeId == null) this.typeInvalid = true;
    // if (this.model.beneficiariesIds == null || this.model.beneficiariesIds.length == 0) this.benInvalid = true;

    // if (form.valid && this.validPhoto && !this.typeInvalid && !this.benInvalid) {
    //   this.isLoading = true;
    //   for (const filee of this.file) {
    //     this.fileName = filee.name;
    //     this.file = filee;
    //     this.formData.append(filee.name, filee);
    //   }
    //   let hasAttachments = false;
    //   this.attachments.forEach(() => {
    //     hasAttachments = true;
    //   });
    //   let hasImage = false;
    //   this.formData.forEach(() => {
    //     hasImage = true;
    //   });

    //   if (hasAttachments && hasImage) {
    //     const imgUpload$ = this.service.uploadFile(this.formData);
    //     const attachementsUpload$ = this.service.uploadFile(this.attachments);
    //     combineLatest([imgUpload$, attachementsUpload$]).subscribe(([img, file]) => {
    //       this.model.fileName = img.fileName;
    //       this.model.guideFileName = file.fileName;
    //       this.service
    //         .post(this.model)
    //         .pipe(
    //           finalize(() => {
    //             this.isLoading = false;
    //           })
    //         )
    //         .subscribe((resp) => {
    //           this.toast.success('تم الحفظ بنجاح', 'نجاح');
    //           this.diagRef.close('true');
    //         });
    //     });
    //   } else if (!hasAttachments && hasImage) {
    //     this.service.uploadFile(this.formData).subscribe((img) => {
    //       this.model.fileName = img.fileName;
    //       this.service
    //         .post(this.model)
    //         .pipe(
    //           finalize(() => {
    //             this.isLoading = false;
    //           })
    //         )
    //         .subscribe((resp) => {
    //           this.toast.success('تم الحفظ بنجاح', 'نجاح');
    //           this.diagRef.close('true');
    //         });
    //     });
    //   }
    // }
  }
  closePopup() {
    this.diagRef.close('false');
  }

  update() {
    this.submit = true;

    if (this.imgURL == null) {
      this.validPhoto = false;
    }
    if (!this.validPhoto || !this.typeValidity || this.benInvalid) {
      if (!this.typeValidity) this.typeInvalid = true;
      if (this.benInvalid) this.benInvalid = true;
      return;
    } else {
      let oldPhoto = {} as FileVm;
      if (this.model.fileName) {
        oldPhoto.fileName = this.model.fileName;
      }
      this.isLoading = true;
      const img$ = this.newPhotoUploaded
        ? this.uploadService.uploadImage(this.formData)
        : this.uploadService.uploadImage(oldPhoto);
      const attachments$ = this.uploadService.uploadFile();
      combineLatest([img$, attachments$])
        .pipe(
          switchMap(([img, file]) => {
            this.model.fileName = img.fileName;
            this.model.guideFileName = file.fileName;
            return this.service.put(this.id, this.model);
          }),
          finalize(() => {
            this.isLoading = false;
          }),
          catchError(() => {
            console.log('error here in combine latest ');
            return of(null);
          })
        )
        .subscribe((resp) => {
          this.diagRef.close('true');
          this.toast.show('تم تعديل الخدمة جديدة بنجاح', '', { status: 'success', duration: 3000 });
        });
    }
  }

  newStep: string = '';
  newStepEN: string = '';
  keywords: string = '';
  keywordsEN: string = '';
  requiredInfo: string = '';
  requiredInfoEN: string = '';

  addStep() {
    if (this.newStep) {
      if (!this.model.steps) this.model.steps = [];
      this.model.steps.push(this.newStep);
      this.newStep = '';
    }
  }

  removeStep(item) {
    this.model.steps = this.model.steps.filter((x) => x !== item);
  }

  addStepEN() {
    if (this.newStepEN) {
      if (!this.model.stepsEN) this.model.stepsEN = [];
      this.model.stepsEN.push(this.newStepEN);
      this.newStepEN = '';
    }
  }

  removeStepEN(item) {
    this.model.stepsEN = this.model.stepsEN.filter((x) => x !== item);
  }

  addkeyword() {
    if (this.keywords) {
      if (!this.model.keywords) this.model.keywords = [];
      this.model.keywords.push(this.keywords);
      this.keywords = '';
    }
  }

  removeKeyword(item) {
    this.model.keywords = this.model.keywords.filter((x) => x !== item);
  }

  addKeywordsEN() {
    if (this.keywordsEN) {
      if (!this.model.keywordsEN) this.model.keywordsEN = [];
      this.model.keywordsEN.push(this.keywordsEN);
      this.keywordsEN = '';
    }
  }

  removekeywordsEN(item) {
    this.model.keywordsEN = this.model.keywordsEN.filter((x) => x !== item);
  }

  addRequiredInfo() {
    if (this.requiredInfo) {
      if (!this.model.requiredInfo) this.model.requiredInfo = [];
      this.model.requiredInfo.push(this.requiredInfo);
      this.requiredInfo = '';
    }
  }

  removeRequiredInfo(item) {
    this.model.requiredInfo = this.model.requiredInfo.filter((x) => x !== item);
  }

  addRequiredInfoEN() {
    if (this.requiredInfoEN) {
      if (!this.model.requiredInfoEN) this.model.requiredInfoEN = [];
      this.model.requiredInfoEN.push(this.requiredInfoEN);
      this.requiredInfoEN = '';
    }
  }

  removeRequiredInfoEN(item) {
    this.model.requiredInfoEN = this.model.requiredInfoEN.filter((x) => x !== item);
  }

  public toolbarSettings: object = {
    items: ['Formats', 'FontColor', 'Alignments', 'OrderedList', 'UnorderedList', 'Undo', 'Redo'],
  };
}
